import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '../../../../services/common';
import { SalesService } from '../../sales.service';
import { BookingListComponent } from '../booking-list/booking-list.component';
import { AccountType, SourceType, UserSubType } from '../../../../../appconfig';
import { IconList } from '../../../../../iconlist';
import { environment } from '../../../../../environments/environment';
import { ToasterService } from '../../../../services/common/toaster.service';
import { ErrorMessages } from '../../../../../errormessages';
declare const $: any

@Component({
  selector: 'app-booking-addupdate',
  templateUrl: './booking-addupdate.component.html',
  styleUrl: './booking-addupdate.component.scss'
})
export class BookingAddupdateComponent {

  @Input() bookingRelatedData: any;
  @Input() context: string = '';
  @Output() changeModalStatus = new EventEmitter<any>();

  form!: FormGroup;
  Submitted = false;
  currentProject: any;
  currentBooking: any;
  bookingDate: Date = new Date()
  selectedDateTime?: string;
  customerList: any;
  currentCustomer: any
  customerIcon: any = environment.assetsImagePath + IconList.UserIcon
  unitSizes: any;
  unitMeasurement: any;
  showOverlay: boolean = false;
  isVisible: boolean = false;
  projectData: any;
  superArea: any;
  builtupArea: any;
  carpetarea: any;
  clientAccountId: any;
  maxDate!: Date;
  isSubmitDisabled = false;

  showCancelledBookings: boolean = false;
  selectedCancelledBooking: any

  //This will have data of only those cancelled booking against which not other bookings created yet
  //purpose of this is to tag any cancelled booking against a fresh booking
  cancelledBookingList: any

  @ViewChild(BookingListComponent) list!: BookingListComponent;
  //Columns to select existing clients
  columns: any = [
    {
      header: '',
      field: 'selection',
      columnType: 'radio'
    },
    {
      header: 'Client Name', field: 'clientName', columnType: 'text'
    },
    { header: 'Pan Card No.', field: 'panCardNo', columnType: 'text' },
    {
      header: 'Contact No.',
      field: 'primaryPhoneNo',
      columnType: 'phone'
    },
  ];

  //columns to show previous cancelled bookings.
  CancelledBookingColumns: any = [
    {
      header: '', field: 'selection', columnType: 'radio'
    },
    {
      header: 'Client Name', field: 'clientName', columnType: 'text'
    },
    { header: 'Unit Category', field: 'product', columnType: 'text' },
    {
      header: 'Booking Date', field: 'bookingDate', columnType: 'date', config: { dateFormat: "dd-MMM-yyyy" }
    },
  ];

  customerListWithClientName: any[] = [];

  constructor(private formBuilder: FormBuilder, private toasterService: ToasterService, public salesService: SalesService, private commonService: CommonService) {
    this.maxDate = new Date();
  }

  ngOnInit() {
    this.currentProject = JSON.parse((localStorage.getItem('selectedProject') as any));
    this.currentBooking = this.bookingRelatedData?.currentRecord;
    this.bookingDate = this.bookingRelatedData?.currentRecord?.bookingDate != undefined ? new Date(this.bookingRelatedData?.currentRecord?.bookingDate) : new Date();
    this.cancelledBookingList = this.bookingRelatedData?.cancelledBookingList
    this.initiateForm();
  }


  /**
  * Initiate/Reset the form data object with initial/default values
  */
  initiateForm() {
    this.form = this.formBuilder.group({
      id: [this.currentBooking?.id],
      project: [this.currentProject?.projectName, Validators.required],
      sourceName: [this.currentBooking?.sourceDetail?.firstName != null ? (this.currentBooking?.sourceDetail?.nameInitialsName + '. ' + this.currentBooking?.sourceDetail?.firstName + ' ' + this.currentBooking?.sourceDetail?.lastName).trim() : '', [Validators.required]],
      nameInitialsId: [this.currentBooking?.clientDetail?.nameInitialsName != null ? this.currentBooking?.clientDetail?.nameInitialsName : '-1', [Validators.required, Validators.min(1)]],
      clientName: [this.currentBooking?.clientDetail?.firstName != null ? (this.currentBooking?.clientDetail?.firstName + ' ' + this.currentBooking?.clientDetail?.lastName).trim() : null, Validators.required],
      clientId: [this.currentBooking?.clientDetail?.id],
      sourceTypeId: [this.currentBooking?.sourceTypeDetail?.id],
      product: [this.currentBooking?.unitCategoryDetail.name != null ? this.currentBooking?.unitCategoryDetail?.name : '', Validators.required],
      unitCategoryId: [this.currentBooking?.unitCategoryDetail?.id, Validators.required],
      customerSource: [SourceType.Direct],
      rateOffered: [this.currentBooking?.rateOffered, [Validators.required]],
      amount: [this.calculateAmount(), [Validators.required]],
      cancelledBookingClientName: [this.selectedCancelledBooking?.clientName],
      previousBookingId: [this.selectedCancelledBooking?.id],
      contactNumber: [
        this.currentBooking?.clientDetail?.primaryPhoneNo,
        [
          Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$'),
        ],
      ],
      remark: [this.currentBooking?.remark],
      bookingDate: [this.currentBooking?.bookingDate, Validators.required],
      paymentPlansId: [this.currentBooking?.paymentPlanDetail?.id ? this.currentBooking?.paymentPlanDetail?.id : '', [Validators.required]],
      panCardNum: [this.currentBooking?.clientDetail?.panCardNo, [Validators.required, Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)]]
    });

    //Set areas as per Unit details
    this.changeUnitCategory(this.bookingRelatedData?.unitcategoryList?.find((x: any) => x.id == this.currentBooking?.unitCategoryDetail?.id), true)
  }


  //#region CUSTOMER LIST
  /**
   * Gets the customer List.
   * @returns {any}
   */
  getCustomersList() {
    this.salesService.getFilterUser(null, null, UserSubType.Client).subscribe((res: any) => {
      if (res) {
        this.customerList = res?.result

        if (this.customerList && this.customerList.length) {
          this.customerListWithClientName = JSON.parse(JSON.stringify(this.customerList));
        } else {
          this.customerListWithClientName = [];
        }

        this.updateCustomerListWithClientName();
      }
    });
  }

  private updateCustomerListWithClientName(): void {
    if (this.customerListWithClientName && Array.isArray(this.customerListWithClientName)) {
      for (let i = 0; i < this.customerListWithClientName.length; i++) {
        this.customerListWithClientName[i].clientName = `${this.customerListWithClientName[i].nameInitial?.name}. ${this.customerListWithClientName[i].firstName} ${this.customerListWithClientName[i].lastName}`;
        this.customerListWithClientName[i].selection = false;
      }
    }
  }

  /**
   * Set the value of formControls of child component/common component.
   * @param {any} data
   */
  setSelecetdCustomer(data: any) {
    // set values to form controls
    if (data) {
      this.form.controls['clientName'].setValue((data?.firstName + ' ' + data?.lastName).trim());
      this.form.controls['contactNumber'].setValue(data?.primaryPhoneNo);
      this.form.controls['nameInitialsId'].setValue(data?.nameInitial?.id);
      this.form.controls['clientId'].setValue(data?.id);
      this.form.controls['panCardNum'].setValue(data?.panCardNo);
      this.clientAccountId = data?.accountId;
      this.showOverlay = false;
    }
  }

  /**
   *set selected cancelled booking as previous booking id
   @param data currently selected cancelled
   */
  setSelectedCancelledBooking(data: any) {
    this.selectedCancelledBooking = data;
    this.form.controls['cancelledBookingClientName'].setValue((data?.clientName).trim() + ' (Booking# ' + data.id + ') ' + data.product);
    this.form.controls['previousBookingId'].setValue((data?.id));
    this.showCancelledBookings = false
  }

  getCurrentCustomerId() {
    var clientId = null;
    //If form opened in edit mode and customer is coming in booking data only then fetch from record
    if (this.form?.controls['clientId'].value == null) {
      if (this.bookingRelatedData?.clientDetail?.id != null)
        clientId = this.bookingRelatedData?.clientDetail?.id
      else if (this.currentCustomer != null)
        clientId = this.currentCustomer?.id
      else
        clientId = null
    }
    else {
      //if for open to add booking and customer was selected from list then customer id already set in form control.
      //fetch it from there only
      clientId = this.form?.controls['clientId'].value
    }

    return clientId
  }

  /**
   * toggle coomon list for cutomer data modal
   */
  toggleCustomerList() {
    this.getCustomersList()
    this.showOverlay = !this.showOverlay;
  }

  /**
 * toggle coomon list for cancelled booking data modal
 */
  toggleCancelledBookingList() {
    this.showCancelledBookings = !this.showCancelledBookings;
  }

  /**
   * Calculates the amount based on unit size and reate offered
   */
  calculateAmount() {
    if (
      this.superArea &&
      this.form.controls['rateOffered']?.value != ''
    ) {
      this.form?.controls['amount'].setValue(
        Number(this.superArea) *
        this.form?.controls['rateOffered']?.value
      );
    }
  }


  /**
   * set category id on product category change
   * @param currentCategory currently selected unit category object
   */
  changeUnitCategory(currentCategory: any, isEdit = false) {
    this.isSubmitDisabled = false;
    if (currentCategory && isEdit == false) {
      if (currentCategory?.numberOfUnits == currentCategory?.noOfBookedUnits) {
        this.toasterService.showError(ErrorMessages.unitCategoryValidation);
        this.isSubmitDisabled = true;
        return;
      }
    }
    this.unitMeasurement = currentCategory?.unitMeasurement?.name;
    this.builtupArea = currentCategory?.builtupArea;
    this.carpetarea = currentCategory?.carpetArea;
    this.superArea = currentCategory?.superArea;
    this.form.controls['unitCategoryId'].setValue(currentCategory?.id);
    this.calculateAmount()
  }

  /**
  * Adds/Updates the booking data
  */
  onSubmit(): void {
    this.Submitted = true;
    // check form is valid or not
    if (this.form?.invalid) {
      return;
    } else {
      // setting values to payload as per api request
      let name = this.commonService?.getUsersFirstLastName(this.form?.value?.clientName);
      var bookingUpdateRequest: any = this.form?.value
      if (bookingUpdateRequest?.id == null && this.currentBooking != null) {
        delete bookingUpdateRequest.id;
      }
      delete bookingUpdateRequest.clientName;
      delete bookingUpdateRequest.contactNumber;
      delete bookingUpdateRequest.customerSource;
      delete bookingUpdateRequest.nameInitialsId;
      delete bookingUpdateRequest.panCardNum;
      delete bookingUpdateRequest.project;
      bookingUpdateRequest.isActive = true
      bookingUpdateRequest.amount = parseInt(this.form.value?.amount.toString()?.replaceAll(",", ""), 10);
      bookingUpdateRequest.clientId = this.getCurrentCustomerId()
      bookingUpdateRequest.projectId = this.currentProject?.id
      //when changing unit category manually then it will set unit category id in product variable otherwise name
      //in that case we will need to find the unit category Id on behalf of name from unit category array
      bookingUpdateRequest.unitCategoryId = isNaN(this.form?.value?.product?.id) ? this.bookingRelatedData?.unitcategoryList?.find((x: any) => x.name == this.form?.value?.product).id : this.form?.value?.product?.id
      delete bookingUpdateRequest.product;
      bookingUpdateRequest.sourceTypeId = SourceType.Direct,
        //Checking if name is assiged to id if name then find id from agentlist array based on name
        bookingUpdateRequest.sourceId = isNaN(this.form?.value?.sourceName) ? this.bookingRelatedData?.agentList?.find((x: any) => (x.nameInitial?.name + '. ' + x.firstName + ' ' + x.lastName).trim() == this.form?.value?.sourceName).id : this.form?.value?.sourceName,
        delete bookingUpdateRequest.sourceName;
      //bookingUpdateRequest.nameInitialsId = isNaN(this.form.value.nameInitialsId) ? this.bookingRelatedData?.nameInitialsList?.find((x: any) => x.name == this.form?.value?.nameInitialsId).id : this.form?.value?.nameInitialsId,
      if (this.bookingRelatedData?.currentRecord) {
        bookingUpdateRequest.accountId = this.bookingRelatedData?.currentRecord?.clientDetail?.accountId;
      } else {
        bookingUpdateRequest.accountId = this.clientAccountId;
      }
      bookingUpdateRequest.clientDetail = {
        nameInitialsId: this.form.controls['nameInitialsId']?.value,
        //nameInitialsName: this.bookingRelatedData?.nameInitialsList?.find((x: any) => x.id == this.form?.controls['nameInitialsId'].value)?.name,
        firstName: name?.firstName,
        lastName: name?.lastName,
        primaryPhoneNo: this.form.controls['contactNumber']?.value,
        panCardNo: this.form.controls['panCardNum']?.value,
        accountTypeId: AccountType.Client
      }
      if (!this.bookingRelatedData?.currentRecord) {
        this.salesService.createBooking(bookingUpdateRequest).subscribe(() => {
          // hiding the edit or add booking modal and resetting the form
          this.toasterService.showSuccess(ErrorMessages.bookingAdd);
          this.form.markAsPristine();
          this.form.reset();
          this.Submitted = false;
          //Close the add update modal and tell parent component to refresh the list
          this.changeModalState(true)
        });
      }
      else {
        delete bookingUpdateRequest?.clientDetail;
        this.salesService.updatebooking(this.currentBooking?.id, bookingUpdateRequest).subscribe(() => {
          // hiding the edit or add booking modal and resetting the form
          this.toasterService.showSuccess(ErrorMessages.bookingUpdate);
          this.form.markAsPristine();
          this.form.reset();
          this.Submitted = false;

          //Close the add update modal and tell parent component to refresh the list
          this.changeModalState(true)
        });
      }
    }
  }

  /**
   * Change the Add/Update modal state to display or hide
   * @param isSubmitted defines if current record was submitted to add/update or not. If yes then refresh booking list otherwise not
   */
  changeModalState(isSubmitted: boolean = false) {
    this.changeModalStatus.emit({
      "showaddUpdateModal": false,
      "isSubmitted": isSubmitted
    })
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls
  }

  //event used to validate length of contact number on keyPress
  _keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
